// removed by extract-text-webpack-plugin
module.exports = {"navbar":"ToSWz43h-X0Tmud1k8NTy","headerThemeDefault":"_94uZri-y4S9Pko6VavpTR","headerThemePrimary":"_32PUl7ao0KYop5sfEJPHoD","headerThemeDark":"_15nFdBwSARJ7QLUYloJF9i","logo":"_1Fu5luDgEZyyO3VK896hh-","sidenavToggle":"_3N7q-UUS2nNj5P8WohV-Ws","menuDivider":"_1zEtMqJiUe1blQlbAIz3d7","navbarPageTitle":"_2sYszzHDlbS0Mk0jsYv4GW","primaryNavigationLeft":"_3s6-6D64zrG3gWHmZhFe0E","primaryNavigationRight":"_3li-kjWZMrNN4Ig6cPvCIi"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/02-organisms/global/header.scss
// module id = 121
// module chunks = 0